'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _searchForm = require('constructicon/search-form');

var _searchForm2 = _interopRequireDefault(_searchForm);

var _searchResult = require('constructicon/search-result');

var _searchResult2 = _interopRequireDefault(_searchResult);

var _searchResults = require('constructicon/search-results');

var _searchResults2 = _interopRequireDefault(_searchResults);

var _pages = require('../../api/pages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageSearch = function (_Component) {
  _inherits(PageSearch, _Component);

  function PageSearch() {
    _classCallCheck(this, PageSearch);

    var _this = _possibleConstructorReturn(this, (PageSearch.__proto__ || Object.getPrototypeOf(PageSearch)).call(this));

    _this.sendQuery = _this.sendQuery.bind(_this);
    _this.state = {
      status: 'inactive',
      data: []
    };
    return _this;
  }

  _createClass(PageSearch, [{
    key: 'sendQuery',
    value: function sendQuery(query) {
      var _this2 = this;

      if (!query) {
        return this.setState({
          q: null,
          status: 'inactive',
          data: []
        });
      }

      this.setState({
        q: query,
        status: 'fetching'
      });

      return (0, _pages.fetchPages)({
        q: query,
        campaign: this.props.campaign,
        charity: this.props.charity,
        event: this.props.event,
        country: this.props.country,
        type: this.props.type,
        group: this.props.group,
        limit: this.props.limit,
        page: this.props.page
      }).then(function (data) {
        _this2.setState({
          status: 'fetched',
          data: data.map(_pages.deserializePage)
        });
      }).catch(function (error) {
        _this2.setState({
          status: 'failed'
        });
        return Promise.reject(error);
      });
    }
  }, {
    key: 'getSubtitle',
    value: function getSubtitle(subtitle, page) {
      switch (typeof subtitle === 'undefined' ? 'undefined' : _typeof(subtitle)) {
        case 'function':
          return subtitle(page);
        default:
          return page[subtitle] ? page[subtitle] : null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_searchForm2.default, _extends({
        onChange: this.sendQuery,
        children: this.state.status !== 'inactive' && this.renderResults(),
        button: this.props.button
      }, this.props.searchForm));
    }
  }, {
    key: 'renderResults',
    value: function renderResults() {
      var _this3 = this;

      var _state = this.state,
          status = _state.status,
          q = _state.q,
          _state$data = _state.data,
          data = _state$data === undefined ? [] : _state$data;
      var subtitle = this.props.subtitle;


      return _react2.default.createElement(
        _searchResults2.default,
        _extends({
          loading: status === 'fetching',
          error: status === 'failed',
          emptyLabel: 'No results found for "' + q + '"'
        }, this.props.searchResults),
        data.map(function (page, i) {
          return _react2.default.createElement(_searchResult2.default, _extends({
            key: i,
            title: page.name,
            subtitle: _this3.getSubtitle(subtitle, page),
            image: page.image,
            url: page.url
          }, _this3.props.searchResult));
        })
      );
    }
  }]);

  return PageSearch;
}(_react.Component);

PageSearch.propTypes = {
  /**
   * The campaign uid to fetch pages for
   */
  campaign: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),

  /**
   * The charity uid to fetch pages for
   */
  charity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),

  /**
   * The event id
   */
  event: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),

  /**
   * The type of page to include in the leaderboard
   */
  type: _propTypes2.default.oneOf(['individual', 'team', 'all']),

  /**
   * The group value(s) to filter by
   */
  group: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * The number of records to fetch
   */
  limit: _propTypes2.default.number,

  /**
   * The page to fetch
   */
  page: _propTypes2.default.number,

  /**
   * What to use as the subtitle on the results
   */
  subtitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),

  /**
   * Props to be passed to the SearchForm component
   */
  searchForm: _propTypes2.default.object,

  /**
   * Props to be passed to the SearchResults component
   */
  searchResults: _propTypes2.default.object,

  /**
   * Props to be passed to the SearchResult components
   */
  searchResult: _propTypes2.default.object,

  /**
   * Props to be passed to the Button components
   */
  button: _propTypes2.default.object
};

PageSearch.defaultProps = {
  limit: 10,
  type: 'individual',
  subtitle: 'charity'
};

exports.default = PageSearch;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/page-search/index.js
// module id = 1439
// module chunks = 0